/**
 * 进程管理
 */
const ApprovalRouter = {
  path: '/project',
  component: () => import('@/views/layout'),
  redirect: '/project/manage/list',
  hidden: true,
  meta: {
    title: 'desc'
  },
  children: [

    // 添加。详情.编辑 长保
    {
      path: 'approval/add',
      name: 'CBAddApproval',
      component: () => import('@/views/approval/addApproval'),
      hidden: true,
      meta: {
        title: '新增立项'
      }
    },
    {
      path: 'approval/edit/:id',
      name: 'CBEditApproval',
      component: () => import('@/views/approval/addApproval'),
      hidden: true,
      meta: {
        title: '编辑立项'
      }
    },
    {
      path: 'approval/desc/:id',
      name: 'CBDescApproval',
      component: () => import('@/views/approval/details'),
      hidden: true,
      meta: {
        title: '详情'
      }
    },
    {
      path: 'approval/detail/:id/:taskId',
      name: 'ApprovalDesc',
      component: () => import('@/views/approval/approval_details'),
      hidden: true,
      meta: {
        title: '详情'
      }
    }

  ]
}

export default ApprovalRouter
